export const environment = {
  production: true,
  webApiUrl: "https://inspect.cotecna.com",
  maxIdleTime: 2700,
  featureManager: {
    functionAppHost: "https://featuremanagerfunctionsprod.azurewebsites.net",
    application: "cotecna_eye",
    environment: "prod",
    functionCodes: {
      getFeatureFlags:
        "OPzv3FJkOguoWoWPEFlU6rHNDEVurnxavJIIfZHpMLVMEaZ3ywtCpw==",
    },
  },
  googleMaps: {
    apiKey: "AIzaSyD4mNOHP6EMGVwoVHdfNFiWUHCJDOy4F_s",
  },
  appInsights: {
    instrumentationKey: "fb0ce000-b28d-4887-9914-6f6c97c55810",
  },
  encryptKey: "zVOL5Hp9e6EsXcN8",
  encryptIV: "MO95jxleFLhTbCeS",
};
